module.exports = __webpack_public_path__ + "static/media/toolbar_death_m_i.64c8a40c.png";